import { Controller } from "@hotwired/stimulus";
import axios from "axios";
import Swal from "sweetalert2";
import Fuse from "fuse.js";
import {
  montarSugestao,
  limparSugestoesEmails,
} from "../helpers/sugestoes_email_helpers";
import intlTelInput from "intl-tel-input/build/js/intlTelInput";
import intlTelInputUtils from "intl-tel-input/build/js/utils";

const emoticonFacial =
  '<svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" fill="none" viewBox="0 0 86 86"><circle cx="43" cy="43" r="43" fill="var(--primaria)"/><path fill="#fff" d="M59.77 33.684a1.864 1.864 0 0 1-1.863-1.863v-3.727H54.18a1.864 1.864 0 0 1 0-3.727h5.59a1.864 1.864 0 0 1 1.863 1.863v5.59a1.863 1.863 0 0 1-1.863 1.864Zm0 16.769h-5.59a1.863 1.863 0 1 1 0-3.726h3.727V43a1.863 1.863 0 1 1 3.726 0v5.59a1.863 1.863 0 0 1-1.863 1.863ZM26.23 33.684a1.863 1.863 0 0 1-1.863-1.863v-5.59a1.863 1.863 0 0 1 1.863-1.864h5.59a1.863 1.863 0 1 1 0 3.727h-3.727v3.726a1.863 1.863 0 0 1-1.863 1.864Zm5.59 16.769h-5.59a1.863 1.863 0 0 1-1.863-1.863V43a1.863 1.863 0 1 1 3.726 0v3.727h3.727a1.863 1.863 0 1 1 0 3.726Zm22.36 13.045H31.82a1.864 1.864 0 0 1-1.863-1.864v-7.36l.931-.559a24.13 24.13 0 0 1 24.224 0l.931.56v7.36a1.864 1.864 0 0 1-1.863 1.863ZM43 29.957a8.384 8.384 0 1 0 0 16.77 8.384 8.384 0 0 0 0-16.77Z"/></svg>'

const dominios = [
  "gmail.com",
  "outlook.com",
  "hotmail.com",
  "uol.com",
  "yahoo.com",
  "icloud.com",
  "live.com",
  "uol.com.br",
  "msn.com",
];

// mostrar-aviso-value

const fuse = new Fuse(dominios);

export default class extends Controller {
  initializeEmailValue = "";

  static values = {
    mostrarAviso: Boolean,
    mostrarModalCadastrarFacial: Boolean
  }

  static targets = [
    "selectPais",
    "aceitouTermo",
    "selectEstado",
    "inputEmail",
    "inputDocumento",
    "inputDataNascimento",
    "inputDocumentoTipo",
    "intlInputTelefone",
    "exigirClienteNaTrocaDeUtilizador",
  ];

  initialize() {
    super.connect();


    if (this.hasMostrarModalCadastrarFacialValue && this.mostrarModalCadastrarFacialValue) {
      MicroModal.show('modal-convite-a-cadastrar-facial')
    }


    this.selectPaisTargets.forEach((target) => {
      $(target).on("change", (event, estadoAtual) => {
        this.mudouPais(
          event.currentTarget.value,
          event.currentTarget.getAttribute("data-identificador-estado"),
          estadoAtual
        );
      });
    });

    this.montarSelectPais();

    if (this.hasInputEmailTarget) {
      $(this.inputEmailTarget).on("input", this.verificarSugestaoEmail);
      this.initializeEmailValue = $(this.inputEmailTarget).val();
    }

    if (this.hasIntlInputTelefoneTarget) {
      if (this.intlInputs?.length > 0) return;

      this.intlInputs = this.intlInputTelefoneTargets.map((target) =>
        intlTelInput(target, {
          preferredCountries: ["br", "us", "es"],
          initialCountry: "br",
          utilsScript: intlTelInputUtils,
          autoPlaceholder: "off",
        })
      );

      this.intlInputs.forEach(
        (input) => (input.telInput.offsetParent.style.width = "100%")
      );
    }
  }

  paisDefault = (selectbox) => {
    const paisDoComprador = selectbox.getAttribute("data-pais-comprador");
    const utilizadorPaisJaPreenchido = selectbox.getAttribute(
      "data-utilizador-pais"
    );

    return utilizadorPaisJaPreenchido || paisDoComprador;
  };

  montarSelectPais = async () => {
    if (this.selectPaisTargets <= 0) return;
    try {
      const response = await axios.get(
        `${this.selectPaisTarget.getAttribute("data-url-get-paises")}.json`
      );
      const paises = response.data;
      let p;

      for (p = 0; p < this.selectPaisTargets.length; p++) {
        let selectbox = this.selectPaisTargets[p];

        const paisDefault = this.paisDefault(selectbox);
        const utilizadorEstadoJaPreenchido = selectbox.getAttribute(
          "data-utilizador-estado"
        );

        //optgroup
        for (var i = 0; i < paises.length; i++) {
          const value = paises[i];
          var optionGroup = document.createElement("OPTGROUP");

          optionGroup.label = value[0];
          selectbox.append(optionGroup);

          //options
          for (var j = 0; j < value[1].length; j++) {
            const pais = value[1][j];
            var option = document.createElement("option");

            //deixar selecionado o pais, caso tenha
            if (paisDefault && pais[1] == paisDefault) {
              this.mudouPais(
                paisDefault,
                selectbox.getAttribute("data-identificador-estado"),
                utilizadorEstadoJaPreenchido
              );
              option.setAttribute("selected", true);
            }

            option.innerHTML = pais[0];
            option.value = pais[1];
            optionGroup.append(option);
          }
        }
      }
    } catch (e) {
      console.error(e);

      Swal.fire({
        title: I18n.t("mensagem_requisicao_falha_pais"),
        text: I18n.t("erro_entre_contato"),
        icon: "error",
        showCancelButton: false,
        confirmButtonText: I18n.t("tentar_novamente"),
      }).then((result) => {
        location.reload();
      });
    }
  };

  async mudouPais(
    paisSigla,
    identificadorEstado,
    utilizadorEstadoJaPreenchido = null
  ) {
    try {
      let selectEstados = document.querySelector(
        `[data-id="${identificadorEstado}"]`
      );

      if (!selectEstados) return;

      if (paisSigla) {
        const response = await axios.get(
          `${this.selectPaisTarget.getAttribute(
            "data-url-get-paises"
          )}/${paisSigla}.json`
        );
        const estados = response.data.estados;

        //deve haver novos estados para eu montar o select
        if (estados.length > 0) {
          // remover os antigos
          this.limparFilhos(selectEstados);

          //default
          var optionDefault = document.createElement("option");
          optionDefault.value = "";
          optionDefault.innerHTML = "";
          selectEstados.append(optionDefault);

          // adicionando novos
          estados.map((estado) => {
            let option = document.createElement("option");

            option.innerHTML = estado.nome;
            option.value = estado.sigla;

            //selecionando já existente
            if (
              utilizadorEstadoJaPreenchido &&
              utilizadorEstadoJaPreenchido == estado.sigla
            ) {
              option.setAttribute("selected", true);
            }

            selectEstados.append(option);
          });
        } else {
          console.error("SEM ESTADOS!!");
        }
      } else {
        this.limparFilhos(selectEstados);

        var optionDefault = document.createElement("option");
        optionDefault.value = "";
        optionDefault.innerHTML = "Selecione um país primeiro";
        selectEstados.append(optionDefault);
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: I18n.t("mensagem_requisicao_falha_estado"),
        text: I18n.t("erro_entre_contato"),
        icon: "error",
        showCancelButton: false,
        confirmButtonText: I18n.t("tentar_novamente"),
      }).then((result) => {
        location.reload();
      });
    }
  }

  limparFilhos(pai) {
    if (pai.options.length <= 0) return;

    let i = pai.options.length - 1;

    for (i; i >= 0; i--) {
      pai.remove(i);
    }
  }

  verificarSugestaoEmail(event) {
    let email = event.currentTarget.value.split("@");

    if (email[1]) {
      limparSugestoesEmails(event.currentTarget);

      let result = fuse.search(email[1]);

      if (result.length >= 1 && result[0].item != email[1]) {
        montarSugestao(email[0], result[0].item, event.currentTarget);
      }
    }
  }

  // Sanitiza o input de telefone no formato +DDIDDDnumero.
  sanitizarDados(event) {
    event.preventDefault();

    if (this.hasInputDocumentoTarget && this.hasInputinputDocumentoTipo && this.inputinputDocumentoTipo.value == 'CPF') {
      this.inputDocumentoTarget.value = this.inputDocumentoTarget.value.replace(/[^\d]/g, "");
    }

    if (this.hasIntlInputTelefoneTarget && this.intlInputs?.length > 0) {
      this.intlInputs.map((target, index) => {
        this.intlInputTelefoneTargets[index].value = target
          .getNumber()
          .replace(/[^\d+]/g, "");
      });
    }

    if (this.hasInputEmailTarget) {
      const { dataset, value } = this.inputEmailTarget;

      if (
        dataset?.exigirClienteNaTrocaDeUtilizador === "true" &&
        this.initializeEmailValue !== value
      ) {
        Swal.fire({
          title: I18n.t("mensagem_troca_utilizador_email_title"),
          text: I18n.t("mensagem_troca_utilizador_email_text"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: I18n.t("sim_continuar"),
          cancelButtonText: I18n.t("cancelar"),
        }).then((result) => {
          if (result.isConfirmed) {
            this._submitForm(event);
          }
        });
        return;
      }
    }

    if (this.hasAceitouTermoTarget && !this.aceitouTermoTarget.checked) {
      Swal.fire({
        title: I18n.t("termos_de_uso_deve_ser_aceito"),
        icon: "warning",
        confirmButtonText: I18n.t("ok"),
      });

      return;
    } else {
      if (this.mostrarAvisoValue) {
        Swal.fire({
          title: I18n.t("mensagem_confirma_que_os_dados_estao_corretos"),
          text: I18n.t("mensagem_apos_confirmar_ja_era"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: I18n.t("confirmar"),
          cancelButtonText: I18n.t("cancelar"),
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this._submitForm(event);
          }
        });
        return;
      }
    }


    this._submitForm(event);
  }

  _submitForm(event) {
    event.target.form.submit();
  }
}
